import { all, call } from 'redux-saga/effects';
import { watchLogin, watchLogout, watchRegister, watchPasswordRecovery, watchCheckAuthentication, checkAuthenticationByInterval } from './authentication';
import {
    watchClubList,
    watchCreateClub,
    watchClubsInfo,
    watchCurrentClub,
    watchCurrentClubHandler,
    watchClubEdit,
    watchDisbandClub,
    watchJoinClub,
    watchCurrentClubMembers,
    watchClubData,
    watchChangeMemberRole,
    fetchCurrentClubMembersByInterval,
    watchExportDataRequests,
} from './club';
import { watchCasinoGamesRequest } from './casinoGames';
import { watchRequestTournamentGameUrl } from './getTournamentGameUrl';
import { watchTournamentCasinoRegister , watchTournamentCasinoUnregister } from './tournamentCasinoRegistration';
import { watchRequestGameUrl } from './getGameUrl';
import { watchClubTables, watchCreateTable } from './table';
import { watchLeaderBoard } from './leaderboard';
import { watchUnreadMessages, watchAllMessages, watchReadMessage, watchSendMessage, fetchMessagesByInterval, watchDeleteMessages } from './messages';
import { onLanguageChange } from './profileSettings';
import { watchChangePassword, watchGlobalAccount, watchLinkEmail, watchRefreshAccountBalance } from './account';
import { watchCareerData } from './career';
import {
  watchChangeMemberStatus,
  watchRemoveMember,
  watchQuitMemberClub,
  watchAgentDetails,
  watchMemberDetails,
} from './member';
import { watchExchangeSapphires } from './exchange';
import { watchBalanceTransfer, watchClubTransfers, watchGameTransfers } from './transfers';
import { watchClubLevelUpdate } from './clubLevel';
import { watchRequestTournaments } from './tournamentCasino';
import { watchDailyBonus } from './bonus';
import { watchCreateUnion, watchJoinUnion,
    watchDisbandUnion, watchUnionMembers,
    watchUnionPendings, watchUnionAcceptDeclineClub,
    watchQuitUnionClub, watchUnionEdit } from './union';
import { watchAvatarMenu, watchSetAvatar, watchAvatarActions } from './avatar';
import watchUpdateSelectedMembers from './selectDownline';
import { watchAgentTransactionRequests, watchAgentTransactionHistoryRequests } from './grantCredit';
import { watchLanguageChanges } from './language';

export default function* rootSaga() {
    yield all([
        call(watchLogin),
        call(watchLogout),
        call(watchCasinoGamesRequest),
        call(watchRequestTournaments),
        call(watchRequestTournamentGameUrl),
        call(watchTournamentCasinoRegister),
        call(watchTournamentCasinoUnregister),
        call(watchRegister),
        call(watchPasswordRecovery),
        call(watchClubTables),
        call(watchCreateTable),
        call(watchClubList),
        call(watchClubsInfo),
        call(watchRequestGameUrl),
        call(watchCreateClub),
        call(watchCurrentClub),
        call(watchCurrentClubHandler),
        call(watchClubEdit),
        call(watchDisbandClub),
        call(watchCurrentClubMembers),
        call(watchJoinClub),
        call(watchClubData),
        call(watchCheckAuthentication),
        call(checkAuthenticationByInterval),
        call(fetchMessagesByInterval),
        call(fetchCurrentClubMembersByInterval),
        call(watchExportDataRequests),
        call(onLanguageChange),
        call(watchLeaderBoard),
        call(watchUnreadMessages),
        call(watchAllMessages),
        call(watchSendMessage),
        call(watchDeleteMessages),
        call(watchReadMessage),
        call(watchChangePassword),
        call(watchCareerData),
        call(watchAvatarMenu),
        call(watchSetAvatar),
        call(watchAvatarActions),
        call(watchChangeMemberStatus),
        call(watchRemoveMember),
        call(watchQuitMemberClub),
        call(watchAgentDetails),
        call(watchMemberDetails),
        call(watchExchangeSapphires),
        call(watchBalanceTransfer),
        call(watchClubTransfers),
        call(watchGameTransfers),
        call(watchGlobalAccount),
        call(watchClubLevelUpdate),
        call(watchCreateUnion),
        call(watchJoinUnion),
        call(watchDisbandUnion),
        call(watchQuitUnionClub),
        call(watchUnionMembers),
        call(watchUnionPendings),
        call(watchUnionAcceptDeclineClub),
        call(watchUnionEdit),
        call(watchChangeMemberRole),
        call(watchDailyBonus),
        call(watchLinkEmail),
        call(watchUpdateSelectedMembers),
        call(watchAgentTransactionRequests),
        call(watchAgentTransactionHistoryRequests),
        call(watchRefreshAccountBalance),
        call(watchLanguageChanges),
    ]);
}
